import React from "react";
import { Helmet } from "react-helmet";

import { UniverseShowcase } from "../components/common/UniverseShowcase/UniverseShowcase";

import I1 from "../assets/images/universe/1.jpg";
import I2 from "../assets/images/universe/2.jpg";
import I3 from "../assets/images/universe/3.jpeg";
import I4 from "../assets/images/universe/4.jpg";
import I5 from "../assets/images/universe/5.jpg";
import I6 from "../assets/images/universe/6.jpg";

const Universe = () => {
  const universeImages = [
    I1,
    I2,
    I3,
    I4,
    I5,
    I6,
  ];

  return (
    <>
      <Helmet>
        <title>LHANGAR Universe — Lembawe9</title>

        <meta
          name="description"
          content="Explore the visual identity, objects, stage concepts and creative world behind the LHANGAR universe."
        />
      </Helmet>

      <main>
        <UniverseShowcase
          images={universeImages}
        />
      </main>
    </>
  );
};

export default Universe;